import ApiService from "@/modules/api/api.service";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import BasicRepository from "@/modules/api/basic.repository";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import { ResourceCollection } from "@/modules/api/resource.collection";

import BatchInvoice from "./batch-invoice.model";

export default class BatchInvoiceRepository extends BasicRepository<BatchInvoice> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<BatchInvoice>,
    responseParser: ApiCollectionResponseParserService<BatchInvoice>
  ) {
    super("batch_invoices", api, objectBuilder, responseParser);
  }

  public getByInvoiceIds(invoiceIds: string[]): Promise<BatchInvoice[]> {
    return this.fetchChunkedByFilter({ invoice: invoiceIds }, "invoice");
  }

  public getByBatchPlushieId(
    batchPlushieId: string,
    useCache = true
  ): Promise<ResourceCollection<BatchInvoice>> {
    return this.fetchList({ batchPlushieId }, 1, 100, undefined, useCache);
  }

  public async updateShippingAmount(
    invoiceId: string,
    shippingAmount: number
  ): Promise<BatchInvoice> {
    const response = await this.api.put(this.resourceName + "/" + invoiceId, {
      shippingAmount,
    });

    return this.objectBuilder.buildFromJSON(response.data);
  }
}
